import React from "react";

export default function SQLServer_MAX() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_MAX</h1>
      <p>This is the SQLServer_MAX component generated from the SQL JSON.</p>
    </div>
  );
}
